import TermCreateEdit from "../AdminTermCreateEdit";

export default class AdminTermCreateEditDistributionReasonType extends TermCreateEdit {
  /**
   * @returns {string} The term type.
   */
  getType() {
    return "distribution_reason_type";
  }
}
